import { cB as t } from "./highrise314.mjs";
const e = t("base-wave", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
`);
export {
  e as default
};
